import { useCallback } from 'react';
import { getLessonImage } from 'api/services/lesson-service';
import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { IGetLessonImageRequest } from '@api/models/request/IGetLessonImageRequest';

export const useGetLessonImage = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IGetLessonImageRequest, Blob>(getLessonImage);

    const getLessonImageBase64 = useCallback(async (lessonId: string) => {
        const resp = await callAPI({lessonId});
        const blob = resp?.data;
        if (!blob || !blob.size) return undefined;

        const dataUrl = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result;
                if (typeof result === 'string') resolve(result);
                else reject(new Error('Failed to read LessonImage blob.'));
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        return dataUrl.split(',')[1];
    }, [callAPI]);

    return { getLessonImageBase64, getLessonImagePending: loading };
};